var _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 215,
    viewBox: "0 0 341 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1160_43667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 63.1017C2 55.4179 6.35577 48.4433 13.3847 45.3392C41.3036 33.0099 114.87 3 169.5 3C224.13 3 297.696 33.0099 325.615 45.3392C332.644 48.4433 337 55.4179 337 63.1017V146.534C337 154.405 332.434 161.515 325.173 164.555C295.88 176.817 218.772 207 169.5 207C120.228 207 43.1198 176.817 13.827 164.555C6.56626 161.515 2 154.405 2 146.534V63.1017Z",
    fill: "#2A1771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 63.1017C2 55.4179 6.35577 48.4433 13.3847 45.3392C41.3036 33.0099 114.87 3 169.5 3C224.13 3 297.696 33.0099 325.615 45.3392C332.644 48.4433 337 55.4179 337 63.1017V146.534C337 154.405 332.434 161.515 325.173 164.555C295.88 176.817 218.772 207 169.5 207C120.228 207 43.1198 176.817 13.827 164.555C6.56626 161.515 2 154.405 2 146.534V63.1017Z",
    fill: "url(#paint0_radial_1160_43667)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 63.1017C10 58.448 12.6104 54.4265 16.6165 52.6574C30.4223 46.5606 55.5004 36.1 83.8292 27.1765C112.293 18.2106 143.415 11 169.5 11C195.585 11 226.707 18.2106 255.171 27.1765C283.5 36.1 308.578 46.5606 322.384 52.6574C326.39 54.4265 329 58.448 329 63.1017V146.534C329 151.299 326.262 155.426 322.084 157.175C307.559 163.255 281.213 173.763 252.446 182.739C223.484 191.775 192.858 199 169.5 199C146.142 199 115.516 191.775 86.554 182.739C57.7872 173.763 31.4407 163.255 16.9161 157.175C12.7377 155.426 10 151.299 10 146.534V63.1017Z",
    stroke: "url(#paint1_linear_1160_43667)",
    strokeWidth: 16
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 147,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 147,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint2_radial_1160_43667)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 161,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 161,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint3_radial_1160_43667)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 176,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 176,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint4_radial_1160_43667)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 187,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 187,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint5_radial_1160_43667)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 194,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 194,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint6_radial_1160_43667)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 187,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 187,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint7_radial_1160_43667)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 176,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 176,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint8_radial_1160_43667)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 161,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 161,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint9_radial_1160_43667)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 147,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 147,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint10_radial_1160_43667)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 116,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 116,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint11_radial_1160_43667)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 82,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 82,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint12_radial_1160_43667)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 116,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 116,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint13_radial_1160_43667)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 82,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 82,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint14_radial_1160_43667)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 51,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 51,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint15_radial_1160_43667)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 37,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 37,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint16_radial_1160_43667)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 22,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 22,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint17_radial_1160_43667)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 11,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 11,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint18_radial_1160_43667)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 5,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 5,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint19_radial_1160_43667)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 11,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 11,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint20_radial_1160_43667)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 22,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 22,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint21_radial_1160_43667)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 37,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 37,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint22_radial_1160_43667)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_dd_1160_43667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 51,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#FCE9A1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 51,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint23_radial_1160_43667)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_1160_43667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6953 100.523L87.375 100.57C87.2969 96.6016 86.2969 94.5156 84.375 94.3125H83.9531C82.2344 94.3125 80.8438 95.4453 79.7812 97.7109C78.7188 99.9766 78.1875 103.188 78.1875 107.344V108.375C78.2812 113.031 79.9141 115.359 83.0859 115.359C85.2734 115.359 86.3672 113.578 86.3672 110.016C86.3672 109.656 86.3594 109.289 86.3438 108.914L81.6797 108.984L81.9141 103.711L93.8906 103.898V109.641L91.5 109.688C91.5 117.844 88.25 121.922 81.75 121.922C75.7344 121.922 72.7266 117.125 72.7266 107.531C72.7266 106.734 72.75 105.898 72.7969 105.023C73.3438 93.7578 76.9297 87.8906 83.5547 87.4219C83.8828 87.4062 84.1953 87.3984 84.4922 87.3984C90.0078 87.3984 92.7656 91.1172 92.7656 98.5547C92.7656 99.1797 92.7422 99.8359 92.6953 100.523ZM94.6172 120.891C97.5547 107.547 99.9297 96.2344 101.742 86.9531L110.531 86.8125C112.688 96.4688 115.156 107.469 117.938 119.812L111.938 121.031L110.039 112.148H102.75L100.781 121.734L94.6172 120.891ZM109.852 105.562C109.039 102.188 107.711 98.1484 105.867 93.4453C104.445 97.3984 103.242 101.492 102.258 105.727L109.852 105.562ZM126.82 87.0703L132.281 111.352L136.289 88.8516L146.977 88.9688C146.789 94.0469 146.695 99.1719 146.695 104.344C146.695 110.109 146.812 115.945 147.047 121.852L140.227 122.32C140.227 116.102 140.156 108.5 140.016 99.5156L136.195 120.117L128.93 120.609L124.242 98.3906L124.148 120.891L118.43 121.289C118.539 116.148 118.594 111.047 118.594 105.984C118.594 99.6719 118.508 93.4375 118.336 87.2812L126.82 87.0703ZM164.203 88.0781V94.6875L154.945 94.3125V102L163.266 101.766L163.477 108.117H156.047V114.07H165.773V120.727L149.555 120.492C149.727 116.102 149.812 111.68 149.812 107.227C149.812 101.055 149.648 94.8281 149.32 88.5469C152.852 88.4062 157.812 88.25 164.203 88.0781ZM187.547 87.2812C194.125 87.2812 197.414 92.9062 197.414 104.156C197.414 115.422 193.891 121.055 186.844 121.055C179.797 121.055 176.273 115.219 176.273 103.547C176.273 92.7031 180.031 87.2812 187.547 87.2812ZM182.859 104.789C182.844 105.195 182.836 105.586 182.836 105.961C182.836 111.852 184.211 114.797 186.961 114.797C189.883 114.797 191.344 111.461 191.344 104.789C191.344 98.1172 189.984 94.7812 187.266 94.7812C184.531 94.7812 183.062 98.1172 182.859 104.789ZM204.164 120.797C202.258 110.266 200 99.2578 197.391 87.7734L204.234 87.0703L208.242 112.758C210.289 103.773 211.961 95.6406 213.258 88.3594L219.75 89.1562C216.469 103.328 214.023 113.789 212.414 120.539L204.164 120.797ZM235.406 88.0781V94.6875L226.148 94.3125V102L234.469 101.766L234.68 108.117H227.25V114.07H236.977V120.727L220.758 120.492C220.93 116.102 221.016 111.68 221.016 107.227C221.016 101.055 220.852 94.8281 220.523 88.5469C224.055 88.4062 229.016 88.25 235.406 88.0781ZM239.414 121.5C239.508 117.031 239.555 112.531 239.555 108C239.555 101.062 239.445 94.0547 239.227 86.9766C241.648 86.7266 243.82 86.6016 245.742 86.6016C251.086 86.6016 254.492 87.5781 255.961 89.5312C257.336 91.3594 258.023 93.375 258.023 95.5781C258.023 96.5781 257.891 97.6094 257.625 98.6719C256.719 102.109 254.812 104.289 251.906 105.211C253.938 105.492 255.477 106.586 256.523 108.492C257.523 110.336 258.023 114.977 258.023 122.414V123.422L250.945 123.516C251.023 121.547 251.062 119.781 251.062 118.219C251.062 113.484 250.68 110.586 249.914 109.523C249.039 108.336 248 107.742 246.797 107.742C246.562 107.742 246.32 107.766 246.07 107.812C246.164 112.578 246.367 117.094 246.68 121.359L239.414 121.5ZM245.414 92.4375L245.578 102.469C248.484 102.328 250.328 101.344 251.109 99.5156C251.531 98.5469 251.742 97.6016 251.742 96.6797C251.742 95.8828 251.586 95.1016 251.273 94.3359C250.711 93.0078 249.312 92.3438 247.078 92.3438C246.562 92.3438 246.008 92.375 245.414 92.4375ZM263.156 121.945C262.219 121.945 261.414 121.609 260.742 120.938C260.07 120.266 259.734 119.461 259.734 118.523C259.734 117.57 260.07 116.758 260.742 116.086C261.414 115.414 262.219 115.078 263.156 115.078C264.109 115.078 264.922 115.414 265.594 116.086C266.266 116.758 266.602 117.57 266.602 118.523C266.602 119.461 266.266 120.266 265.594 120.938C264.922 121.609 264.109 121.945 263.156 121.945ZM266.039 88.9453C265.82 96.8984 265.672 104.758 265.594 112.523L260.391 112.641C260.234 105.984 260.055 98.0859 259.852 88.9453H266.039Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1160_43667",
    x: 2,
    y: 3,
    width: 339,
    height: 212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.447059 0 0 0 0 0.054902 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1160_43667",
    x: 2,
    y: 142,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_1160_43667",
    x: 33,
    y: 156,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_1160_43667",
    x: 73,
    y: 171,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_1160_43667",
    x: 115,
    y: 182,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_1160_43667",
    x: 157,
    y: 189,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dd_1160_43667",
    x: 200,
    y: 182,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dd_1160_43667",
    x: 241,
    y: 171,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dd_1160_43667",
    x: 281,
    y: 156,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_dd_1160_43667",
    x: 316,
    y: 142,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_dd_1160_43667",
    x: 319,
    y: 111,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_dd_1160_43667",
    x: 319,
    y: 77,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_dd_1160_43667",
    x: 0,
    y: 111,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_dd_1160_43667",
    x: 0,
    y: 77,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_dd_1160_43667",
    x: 2,
    y: 46,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_dd_1160_43667",
    x: 33,
    y: 32,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_dd_1160_43667",
    x: 73,
    y: 17,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_dd_1160_43667",
    x: 115,
    y: 6,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_dd_1160_43667",
    x: 157,
    y: 0,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_dd_1160_43667",
    x: 200,
    y: 6,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_dd_1160_43667",
    x: 241,
    y: 17,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_dd_1160_43667",
    x: 281,
    y: 32,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_dd_1160_43667",
    x: 316,
    y: 46,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.911333 0 0 0 0 0.683333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.124167 0 0 0 0 0.41957 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1160_43667",
    result: "effect2_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_1160_43667",
    x: 62.7266,
    y: 81.6016,
    width: 213.875,
    height: 56.9141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.0941176 0 0 0 0 0.443137 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1160_43667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1160_43667",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170 105) rotate(90) scale(63.5 265.805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE6BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE6BFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1160_43667",
    x1: 169.5,
    y1: 3,
    x2: 169.5,
    y2: 207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F54C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52C88"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5833 150.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.5833 164.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.5833 179.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.583 190.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.583 197.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.583 190.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(250.583 179.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(290.583 164.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.583 150.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(328.583 119.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(328.583 85.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.58333 119.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.58333 85.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5833 54.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.5833 40.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.5833 25.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.583 14.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.583 8.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(209.583 14.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(250.583 25.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(290.583 40.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1160_43667",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.583 54.75) rotate(63.435) scale(4.65847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C16B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverTop);
export default __webpack_public_path__ + "static/media/over-top.7a6a9b59.svg";
export { ForwardRef as ReactComponent };